import SMRestClient from 'lib/SMRestClient';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import sprintf from 'sprintf';

class SMUserResource {

  static getUser(userId, completion){
    const url = `/1/users/${userId}`;
    const apiClient = new SMRestClient();
    apiClient.get(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getUsers(queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/users.json" + q;
    const apiClient = new SMRestClient();
    apiClient.get(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static updateUser(formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/users/me.json" + q;
    const apiClient = new SMRestClient();
    const request = apiClient.patch(url, formData);
    request.
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
    return request;
  }

  static requestReviewCertificate(queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/users/me/certificate/request_review.json" + q;
    const apiClient = new SMRestClient();
    const request = apiClient.patch(url, {});
    request.
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
    return request;
  }

  static getBrowseHistories(currentUser, queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const userId = currentUser ? currentUser.username : '-';
    const url = sprintf("/1/users/%s/browse_histories.json", userId) + q;
    const apiClient = new SMRestClient();
    apiClient.get(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getSearchHistories(currentUser, queries, completion){
    queries["per_page"] = queries["per_page"] || 50;
    const q = SMFormatHelper.getUrlArgString(queries);
    const userId = currentUser ? currentUser.username : '-';
    const url = sprintf("/1/users/%s/search_histories.json", userId) + q;
    const apiClient = new SMRestClient();
    apiClient.get(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getNotifications(id, queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/users/"+ id +"/notifications.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static checkNotifications(id, queries, completion){
  queries["per_page"] = queries["per_page"] || 20;
  const q = SMFormatHelper.getUrlArgString(queries);
  const apiClient = new SMRestClient();
  apiClient.patch("/1/users/"+ id +"/notifications/check.json" + q).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }

  // トップページ表示の際に必要
  static getFavorites(id, queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/users/"+ id +"/favorites.json" + q).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }

  static getFavoriteLists(id, completion){
    const apiClient = new SMRestClient();
    apiClient.get("/1/users/" + id + "/favorite_lists.json").
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }

  static postFavoriteList(id, name, completion){
    const url = "/1/users/" + id + "/favorite_lists.json";
    const apiClient = new SMRestClient();
    let formData = new FormData();
    formData.append("name", name);
    apiClient.post(url, formData).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }

  static deleteFavoriteList(user_id, favorite_list_id, completion){
    const url = "/1/users/"+ user_id +"/favorite_lists/"+ favorite_list_id +".json";
    const apiClient = new SMRestClient();
    apiClient.destroy(url).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }

  static updateFavoriteList(user_id, favorite_list_id, name, completion){
    const url = "/1/users/"+ user_id +"/favorite_lists/"+ favorite_list_id +".json";
    const apiClient = new SMRestClient();
    let formData = new FormData();
    formData.append("name", name);
    apiClient.patch(url, formData).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }

  static getListedFavorites(id, favorite_list_id, queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/users/"+ id +"/favorite_lists/"+ favorite_list_id +".json" + q).
    done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
    });
  }

  static postListedFavorite(user_id, favorite_list_id, favoritable_id, favorable_type, completion){
    const url = "/1/users/" + user_id + "/favorite_lists/" + favorite_list_id + "/favorites.json";
    const apiClient = new SMRestClient();
    let formData = new FormData();
    formData.append("favorable_type", favorable_type);
    formData.append("favorable_id", favoritable_id);
    apiClient.post(url, formData).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }

  static deleteListedFavorite(user_id, favorite_list_id, favoritable_id, favorable_type, completion){
    const url = "/1/users/" + user_id + "/favorite_lists/" + favorite_list_id + "/favorites.json";
    const apiClient = new SMRestClient();
    let formData = new FormData();
    formData.append("favorable_type", favorable_type);
    formData.append("favorable_id", favoritable_id);
    apiClient.destroy(url, formData).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }

  static updateListedFavorite(user_id, favorite_list_id, favoritable_id, favorable_type, memo, completion){
    const url = "/1/users/" + user_id + "/favorite_lists/" + favorite_list_id + "/favorites.json";
    const apiClient = new SMRestClient();
    let formData = new FormData();
    formData.append("favorable_type", favorable_type);
    formData.append("favorable_id", favoritable_id);
    formData.append("memo", memo);
    apiClient.patch(url, formData).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }

  static readNotification(id, notificationId, queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/users/"+ id +"/notifications/" + notificationId + "/read.json" + q;
    const apiClient = new SMRestClient();
    apiClient.patch(url, {}).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static postFavorite(user_id, favoritable_id, favorable_type, completion){
    const url = "/1/users/" + user_id + "/favorites.json";
    const apiClient = new SMRestClient();
    let formData = new FormData();
    formData.append("favorable_type", favorable_type);
    formData.append("favorable_id", favoritable_id);

    apiClient.post(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static postContact(user_id, formData, completion){
    const url = "/1/users/" + user_id + "/contact.json";
    const apiClient = new SMRestClient();

    apiClient.post(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static deleteFavorite(user_id, favoritable_id, favorable_type, completion){
    const url = "/1/users/" + user_id + "/favorites.json";
    const apiClient = new SMRestClient();
    let formData = new FormData();
    formData.append("favorable_type", favorable_type);
    formData.append("favorable_id", favoritable_id);

    apiClient.destroy(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getOwners(id, queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/users/"+ id +"/owners.json" + q;
    const apiClient = new SMRestClient();
    apiClient.get(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static postMessage(reservation, formData, completion){
    const url = "/1/users/" + reservation.user.username + "/reservations/" + reservation.uid + "/messages.json";
    const apiClient = new SMRestClient();
    apiClient.post(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getReservation(userId, id, completion){
    const apiClient = new SMRestClient();
    apiClient.get("/1/users/"+ userId +"/reservations/"+ id +".json").
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getReputation(reservation, completion){
    const url = "/1/users/"+ reservation.user.id +"/reservations/"+ reservation.id +"/reputation.json";
    const apiClient = new SMRestClient();
    apiClient.get(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static postReputation(reservation, formData, completion){
    const url = "/1/users/"+ reservation.user.id +"/reservations/"+ reservation.id + "/reputation.json";
    const apiClient = new SMRestClient();
    apiClient.post(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static updateReputation(reservation, formData, completion){
    const url = "/1/users/"+ reservation.user.id +"/reservations/"+ reservation.id + "/reputation.json";
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getReservations(userId, queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/users/"+ userId +"/reservations.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static searchReservations(userId, queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/users/"+ userId +"/search/reservations.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }


  static cancel(reservation, formData, completion){

    const url = sprintf("/1/users/%s/reservations/%s/cancel",
      reservation.user.username, reservation.id);
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static closeMessage(reservation, formData, completion){
    const url = sprintf("/1/users/%s/reservations/%s/close_message",
      reservation.user.username, reservation.id);
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getPayment(userId, completion){
    const apiClient = new SMRestClient();
    apiClient.get("/1/users/"+ userId +"/payment.json").
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }

  static getPayments(userId, completion){
    const apiClient = new SMRestClient();
    apiClient.get("/1/users/"+ userId +"/payments.json").
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }

  static payReservation(userId, reservationId, data, completion){
    const apiClient = new SMRestClient();
    apiClient.patch("/1/users/"+ userId + "/reservations/" + reservationId + "/pay.json", data).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }

  static getContact(id, completion){
    const url = "/1/users/"+ id +"/contact.json";
    const apiClient = new SMRestClient();
    apiClient.get(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static deletePayment(userId, paymentId, completion){
    const apiClient = new SMRestClient();
    apiClient.destroy("/1/users/" + userId + "/payments/" + paymentId).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static postPayment(user_id, token, completion){
    const url = "/1/users/" + user_id + "/payment.json";
    const apiClient = new SMRestClient();
    let formData = new FormData();
    formData.append("token", token);

    apiClient.post(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static updatePassword(formData, completion){
    const url = "/1/account/password.json";
    const apiClient = new SMRestClient();
    const request = apiClient.patch(url, formData);
    request.
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
    return request;
  }

  static updateReservation(userId, reservationId, formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/users/" + userId + "/reservations/" + reservationId + ".json" + q;
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        completion(null, error, xhr);
      });
  }

  static applyCoupon(userId, reservationId, formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/users/" + userId + "/reservations/" + reservationId + "/apply_coupon.json" + q;
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      completion(null, error, xhr);
    });
  }

  static getDashboard(userId, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/users/"+ userId +"/dashboard.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static approveReservation(reservation, formData, completion){
    const url = sprintf("/1/users/%s/reservations/%s/approve_change",
      reservation.user.username, reservation.id);
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }

  static rejectReservation(reservation, formData, completion){
    const url = sprintf("/1/users/%s/reservations/%s/reject_change",
      reservation.user.username, reservation.id);
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }

  static changePayment(reservation, formData, completion){
    const url = sprintf("/1/users/%s/reservations/%s/change_payment",
      reservation.user.username, reservation.id);
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      console.error(error);
      completion(null, error, xhr);
    });
  }

  static getPointHistories(currentUser, queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const userId = currentUser ? currentUser.username : '-';
    const url = sprintf("/1/users/%s/point_histories.json", userId) + q;
    const apiClient = new SMRestClient();
    apiClient.get(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getPoints(currentUser, queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const userId = currentUser ? currentUser.username : '-';
    const url = sprintf("/1/users/%s/points.json", userId) + q;
    const apiClient = new SMRestClient();
    apiClient.get(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static applyPoint(userId, reservationId, formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/users/" + userId + "/reservations/" + reservationId + "/apply_point.json" + q;
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      completion(null, error, xhr);
    });
  }

  static recalcGuestAmount(userId, reservationId, formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = `/1/users/${userId}/reservations/${reservationId}/recalc_guest_amount.json${q}`;
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      completion(null, error, xhr);
    });
  }

  static getAttentionWeeklyGuests(roomUid, completion){
    const url = '/1/rooms/' + roomUid + '/attention.json';
    const apiClient = new SMRestClient();
    apiClient.get(url).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      completion(null, error, xhr);
    });
  }
}
export default SMUserResource;



// WEBPACK FOOTER //
// ./app/javascript/resources/SMUserResource.js